import React, { Component } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, RadioGroup } from '../../../../itrust_common/components/form';

class DiscountField extends Component {
  constructor(props) {
    super(props);
    this.state = { discountType: props.defaultType || 'cash' };
  }

  render() {
    const {
      cashName,
      percentageName,
      discountTypeName,
      prependClasses,
      currency,
      onBlur,
      disabled,
      itemId,
      promoItemId,
    } = this.props;

    // Freeze discount only for the promoted item (orders_promotion.item_id)
    const isDisabled = Boolean(
      disabled !== undefined
        ? disabled
        : itemId != null &&
          promoItemId != null &&
          String(itemId) === String(promoItemId)
    );

    return (
      <div
        className={`input-group flex-nowrap ${isDisabled ? 'disabled' : ''}`}
        style={isDisabled ? { pointerEvents: 'none', opacity: 0.65 } : {}}
      >
        <div className="input-group-prepend">
          <span className={`input-group-text ${prependClasses || ''}`}>
            <RadioGroup
              disabled={isDisabled}
              onChangeHook={(val) => {
                this.setState({ discountType: val });
              }}
              ref={discountTypeName}
              name={discountTypeName}
              radioLabelClasses="px-3"
              onChange={onBlur}
              options={[
                { label: currency?.symbol || '$', value: 'cash' },
                { label: ' % ', value: 'percentage' },
              ]}
            />
          </span>
        </div>
        {this.state.discountType === 'cash' ? (
          <Field
            ref={cashName}
            name={cashName}
            component={Input}
            disabled={isDisabled}
            className="form-control"
            onBlur={onBlur}
          />
        ) : (
          <Field
            ref={percentageName}
            name={percentageName}
            component={Input}
            disabled={isDisabled}
            className="form-control"
            onBlur={onBlur}
          />
        )}
      </div>
    );
  }
}

DiscountField.propTypes = {
  cashName: PropTypes.string,
  percentageName: PropTypes.string,
  discountTypeName: PropTypes.string,
  prependClasses: PropTypes.string,
  defaultType: PropTypes.string,
  currency: PropTypes.object,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  promoItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DiscountField = connect((state) => {
  const {
    organisation: { organisation },
    order,
  } = state;
  const promo = order?.order?.orders_promotion;

  return {
    currency: organisation?.preferences?.currency,
    promoItemId: promo?.item_id || promo?.configuration?.item_id,
  };
})(DiscountField);

export default DiscountField;
